export default {
    event_create_success_message: "The event has been created",
    event_create_title: "Create Event",
    event_edit_success_message: "The event has been edited",
    event_edit_title: "Edit Event",
    event_name: "Name",
    event_status: "Status",
    event_active: "Active",
    event_inactive: "Inactive",
    event_diagnostic: "Diagnostic",
    event_tab_general: "General",
    event_tab_unit_type_event: "Unit Type Event"
}